import React from 'react';
import { Column } from 'spw-shared/globalComponents/grid';
import { SPACE_NAME_MAP } from 'spw-constants';
import { CalculationAssumptionsDialog } from 'spw-components/dialogs/worksheet/calulation-assumptions-dialog';
import {
  RatioCalculationType,
  IProjectSettings,
} from 'spw-redux/modules/settings/types';

import { GridRow } from 'spw-programming-projects/building-details/worksheet/styles';
import useUnitConversion from 'spw-components/unit-conversion/hooks';
import { useSelector } from 'react-redux';
import { selectMeasurementSystem } from 'spw-redux/modules/user/selectors';
import { MeasurementSystem } from 'spw-components/unit-conversion/types';
import { GridHeaderColumn } from './styles';

interface IStorageCategoryHeader {
  spaceType: string;
  projectSettings: IProjectSettings;
  isDownload?: boolean;
}

const StorageCategoryHeader: React.FC<IStorageCategoryHeader> = ({
  spaceType,
  projectSettings,
  isDownload,
}) => {
  const { getUnit } = useUnitConversion();
  const measurementSystem = useSelector(selectMeasurementSystem);

  const title =
    spaceType === SPACE_NAME_MAP.SUPPORT_SPACES.FILE_CABINET
      ? 'Drawers'
      : 'Lockers';
  let secondaryLabel = 'Locker Bank';
  if (title === 'Drawers') {
    secondaryLabel = 'Cabinets';
  }
  let compare = ' : Seats';
  if (
    spaceType === SPACE_NAME_MAP.SUPPORT_SPACES.FILE_CABINET &&
    projectSettings.fileCabinetRatioCalculationType !==
      RatioCalculationType.WORK_SEATS
  ) {
    compare = ' : HC';
  }
  if (
    spaceType !== SPACE_NAME_MAP.SUPPORT_SPACES.FILE_CABINET &&
    projectSettings.lockerRatioCalculationType !==
      RatioCalculationType.WORK_SEATS
  ) {
    compare = ' : HC';
  }

  return (
    <GridRow className="header">
      <GridHeaderColumn xs={3} />
      <GridHeaderColumn xs={1} style={{ paddingRight: '16px' }}>
        <Column>
          <span style={{ whiteSpace: 'nowrap' }}>
            {title.toUpperCase()}
            {compare.toUpperCase()}
          </span>
          <span>RATIO</span>
        </Column>
      </GridHeaderColumn>
      <GridHeaderColumn xs={1} style={{ paddingRight: '16px' }}>
        <Column>
          <div>QTY OF</div>
          <div>{title.toUpperCase()}</div>
        </Column>
      </GridHeaderColumn>
      <GridHeaderColumn xs={1}>
        <Column>
          <div>{title.toUpperCase()}</div>
          <div>HIGH (QTY)</div>
        </Column>
      </GridHeaderColumn>
      <GridHeaderColumn xs={1} style={{ paddingRight: '8px' }}>
        <Column>
          <div>QTY OF</div>
          <div style={{ whiteSpace: 'nowrap' }}>
            {secondaryLabel.toUpperCase()}
            {title !== 'Drawers' ? 'S' : ''}
          </div>
        </Column>
      </GridHeaderColumn>
      <GridHeaderColumn xs={2} className="seat-percent-column">
        <Column>
          <span style={{ whiteSpace: 'nowrap' }}>
            {spaceType === SPACE_NAME_MAP.SUPPORT_SPACES.FILE_CABINET
              ? secondaryLabel.toUpperCase()
              : 'BANKS'}
            {compare.toUpperCase()}
          </span>
          <span>RATIO</span>
        </Column>
      </GridHeaderColumn>
      <GridHeaderColumn xs={2} style={{ justifyContent: 'space-between' }}>
        {!isDownload && <CalculationAssumptionsDialog />}
        <Column style={{ paddingRight: '8px' }}>
          <span>DIMENSIONS</span>
          <span>
            (
            {measurementSystem === MeasurementSystem.imperial ? 'INCHES' : 'mm'}
            )
          </span>
        </Column>
      </GridHeaderColumn>
      <GridHeaderColumn xs={1}>
        <Column>
          <span style={{ whiteSpace: 'nowrap' }}>UNIT SIZE</span>
          <span>
            (SQ{' '}
            {getUnit('linear', {
              outputIsFractionUnit:
                measurementSystem === MeasurementSystem.imperial,
            }).toUpperCase()}
            )
          </span>
        </Column>
      </GridHeaderColumn>
      <GridHeaderColumn xs={1} style={{ paddingRight: '8px' }}>
        <Column>
          <span>TOTAL {getUnit('area')}</span>
          <span>(SQ {getUnit('linear').toUpperCase()})</span>
        </Column>
      </GridHeaderColumn>
    </GridRow>
  );
};

export default StorageCategoryHeader;
